import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { UserData } from '../../domain/models/userData';
import { UserDomainService } from '../../domain/services/user/user.domain.service';
import { LoginDomainService } from '../../domain/services/login/login.domain.service';
import { JobDomainService } from 'app/modules/domain/services/job/job.domain.service';


@Injectable()
export class AuthService {
    private previousRoute = '';
    constructor(
        private userDomainService: UserDomainService,
        private loginDomainService: LoginDomainService,
        private jobDomainService: JobDomainService,
        private router: Router
    ) {
        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .pairwise().subscribe((e: any) => {
                this.previousRoute = e[0].url;
            });
    }

    getUserSettings(): Promise<UserData> {
        return this.userDomainService.getUserData();
    }

    updateUserSettings(userData: UserData): void {
        this.userDomainService.updateUserData(userData);
    }

    getDecodedJwtToken(): any {
        return this.loginDomainService.getDecodedAccessToken();
    }

    checkImpersonation(): boolean {
        return this.loginDomainService.checkImpersonation();
    }

    getPreviousRoute(): string {
        return this.previousRoute;
    }

    isAuthenticated(): boolean {
        return this.loginDomainService.isAuthenticated();
    }

    setUserToken(userToken: any): void {
        return this.loginDomainService.setCurrentAccessToken(userToken);
    }

    clearDraftRoutes(): void {
        this.jobDomainService.clearDraftRoutesFromLocalStorage();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/services/auth.service.ts